/*eslint no-undef: "off"*/

import { useMutation } from '@tanstack/vue-query'

// Marks one recipient row (`id`) unread, or every read row scoped to `resourceId` (all when omitted).
export function useQueryNotificationUserMarkUnread() {
    const { featureFlags } = useAnalytics()

    async function markUnread({ id = null, resourceId = null } = {}) {
        const { dashboardAPI } = useAPI()

        if (id) return dashboardAPI(`/notifications/user/${id}/unread`, { method: 'PATCH' })

        return dashboardAPI('/notifications/user/unread', {
            method: 'PATCH',
            body: resourceId ? { resource_id: resourceId } : {},
        })
    }

    return useMutation({
        // No-ops while the notifications flag is off so nothing reaches the API.
        mutationFn: (scope) => (featureFlags.signalWatchNotifications ? markUnread(scope) : null),
    })
}
